import repository from '@/repositories/repository'
import urlUtil from '@/utils/url'

export default baseUrl => {

    baseUrl = `${baseUrl}/almoxarifado`

    const headers = { responseType: "arraybuffer" }

    return {
       relatorioConsumoFinanceiro(queryParms) {

            return repository.get(`${baseUrl}/relatorio-consumo-financeiro?${urlUtil.serialize(queryParms)}`, headers)
        },
       relatorioEntrada(queryParms) {

            return repository.get(`${baseUrl}/relatorio-entrada?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioEstornoEntrada(queryParms) {

            return repository.get(`${baseUrl}/relatorio-estorno-entrada?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioEstornoSaida(queryParms) {

            return repository.get(`${baseUrl}/relatorio-estorno-saida?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioValidadeMaterial(queryParms) {

            return repository.get(`${baseUrl}/relatorio-validade-material?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioSaida(queryParms) {

            return repository.get(`${baseUrl}/relatorio-saida?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioPosicaoEstoque(queryParms) {

            return repository.get(`${baseUrl}/relatorio-posicao-estoque?${urlUtil.serialize(queryParms)}`, headers)
        },
        relatorioRequisicao(queryParms) {

            return repository.get(`${baseUrl}/relatorio-requisicao?${urlUtil.serialize(queryParms)}`, headers)
        },
    }
}
